module.exports = require("./ar-KW");